export enum EContactByCountryAnalyticType {
    BY_BILLING_ADDRESS = 'by_billing_address',
    BY_SHIPPING_ADDRESS = 'by_shipping_address'
}
